import { render, staticRenderFns } from "./Wfdetector.vue?vue&type=template&id=ce909c62&"
import script from "./Wfdetector.vue?vue&type=script&lang=js&"
export * from "./Wfdetector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports